<template>
    <v-dialog v-model="dialogModel" max-width="950">

        <toolbar-page title="Project selector" disable-icon>
            <template slot="buttons">

                <v-btn class="mr-2"
                       @click="doneClicked"
                       color="primary">DONE</v-btn>

                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" @click="closeButtonClicked">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <v-card v-if="dialogModel">

            <v-container fluid>
                <list-projects-active-table :projects="getFilteredProjects"
                                            :loading="projectsLoading"
                                            select-mode="multiple"
                                            :selected="selectedModel"
                                            @selected="projectsSelected"
                ></list-projects-active-table>
            </v-container>

        </v-card>

    </v-dialog>

</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
import ToolbarPage from "../../../components/UI/ToolbarPage";
import ListProjectsActiveTable from "../../ProjectManager/components/ListProjectsActiveTable";

export default {

    name: "ProjectSelector",

    components: {
        ListProjectsActiveTable,
        ToolbarPage,
        Json
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        projects: {
            required: true,
            type: Array,
        },
        selected: {
            required: false,
            type: Array | null,
            default: () => []
        }
    },

    data() {
        return  {
            selectedModel: [],
        }
    },

    watch: {
        selected() {
            this.selectedModel = [...this.selected];
        }
    },

    computed: {

        ...mapState('ProjectManager', [
            'projectsLoading'
        ]),

        ...mapGetters('ProjectManager', [
            'getFilteredProjects'
        ]),

        dialogModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {

        closeButtonClicked() {
            this.$emit('input', false);
        },

        projectsSelected(ids) {
            this.selectedModel = ids;
        },

        doneClicked() {
            this.$emit('selected', this.selectedModel);
            this.$emit('input', false);
        }
    },

    mounted() {
        this.selectedModel = [...this.selected];
    }
}
</script>
